import React, { Component, Fragment, useEffect } from 'react';
import { connect } from 'react-redux';
import { OrderDetailEminPay } from './OrderDetailEminPay';
import { CreditCardEminPay } from './CreditCardEminPay';
import {
    getExpensesByMemberNo,
    selectMemberExpenseByMemberNo
} from "../../../state/ducks/member/index";
import { createPaymentPayFor, selectPayment, selectCurrentPage, changeCurrentPage, getActiveMemberNumber, getPaymentSum, selectPaymentSum, getActiveMemberNoList } from "../../../state/ducks/payment/index"
import $ from 'jquery';
import Modal from '../Modal';
import { createPaymentPages } from '../../../state/ducks/payment/types';

const pageStatus = [createPaymentPages.orderDetail, createPaymentPages.creditCard, createPaymentPages.sms];

export class CreatePaymentOrderEminPay extends Component {

    state = {
        page: createPaymentPages.orderDetail,
        payment: {
            orderdetail: {
                memberNo: "0",
                startDate: new Date(),
                aylikTutar: "",
                aylikTutarOndalik: 0,
                installmentCount: "",
                paymentType: 1,
            },
            creditcard: {
                cardHolderName: "",
                cardNumber: "",
                expirationMonth: new Date().getMonth() + 1,
                expirationYear: new Date().getFullYear(),
                cvv: "",
                cardType: "",
                bank: "",
                bankCode: "",
                businessCard: ""
            },
            sms: {
                sms: "",
                gsm: ""
            },
        }
    };
    componentDidMount() {
        this.props.changeCurrentPage(createPaymentPages.orderDetail)
        this.props.getMemberNumber();
        this.props.getActiveMemberNo();
        $("#aciklama").modal('show');

        if (this.state.page == "sms") {
        }

        const { paymentType } = this.props.location.state;
        this.setState(prevState => ({
            payment: {
                ...prevState.payment,
                orderdetail: {
                    ...prevState.payment.orderdetail,
                    paymentType: paymentType
                }
            }
        }));
    }
    componentWillReceiveProps(nextProps) {
        var pageName = nextProps.payment.page;
        if (pageName != null && pageName != "") {
            this.setState({ page: pageName });
        }
    }
    changePage = (pageName, clearSmsCode) => {
        var currPage = this.state.page;
        if (pageName == "sms") {
            this.createPaymentPayFor(currPage, pageName);
        }
        else {
            this.props.changeCurrentPage(pageName);
        }

    }
    getExpensesByMemberNo = (memberNo, paymentType) => {

        this.props.getMemberExpense(memberNo, paymentType);
    }
    getPaymentSum = (memberNo) => {
        this.props.getPaymentSummary(memberNo)
    }
    createPaymentPayFor = (currPage, pageName) => {
        var data = this.state.payment;
        if (data.orderdetail.startDate instanceof Date) {
            data.orderdetail.startDate = data.orderdetail.startDate.toLocaleDateString("tr-TR");
        }
        this.props.createPaymentOrder(data, currPage, pageName);
    }

    render() {
        const options = {
            decodeEntities: true,
        };

        var page = this.state.page;
        const { alert, payment } = this.props;
        if (page == "sms") {
            return (
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 p-0">
                            <div>{ }</div>
                            <iframe width="100%" id='eminPay-iframe'
                                height="640px" frameBorder="0" src={"data:text/html," + encodeURIComponent(payment.response.messages[0])} />
                        </div>
                    </div>
                </div>
            )
        }
        else {
            return (
                <div className="contanier-fluid">
                    <Modal message={alert?.message} type={alert?.type} />

                    {page == createPaymentPages.orderDetail ? (
                        <OrderDetailEminPay

                            changePage={this.changePage}
                            orderdetail={this.state.payment.orderdetail}
                            getExpense={this.getExpensesByMemberNo}
                            expenses={this.props.expenses}
                            getPaymentSummmary={this.getPaymentSum}
                            payment={this.props.payment}>
                        </OrderDetailEminPay>)
                        : page == createPaymentPages.creditCard ? (
                            <CreditCardEminPay
                                changePage={this.changePage}
                                creditcard={this.state.payment.creditcard}
                                orderdetail={this.state.payment.orderdetail}
                                createPaymentPayFor={this.createPaymentPayFor}>
                            </CreditCardEminPay>)
                            : (<div></div>)
                    }


                    <div className="modal" id="aciklama" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
                        <div className="t-modalAreaMailOrder" id="id-modal" style={{ display: "block" }}>
                            {/* Bu kısım animasyon için Hareket eden kısım. */}
                            <div className="t-modalContentMailOrder" id="id-modalTipi" style={(window.innerWidth <= 900) ? { width: "89%" } : { width: "51%" }}>
                                <div
                                    className="t-modalMailOrder"
                                    id="id-modalGenel"
                                    style={{ backgroundColor: "rgb(255, 255, 255)", boxShadow: "3px 3px 3px #939191" }}
                                >
                                    <div className="container-fluid">
                                        {/* Header */}
                                        <div className="row t-modalHeaderMailOrder">
                                            <div
                                                className="col"
                                                id="id-modalHeader"
                                                style={{ color: "rgb(119, 119, 119)" }}
                                            >
                                                TALİMAT GÖNDERİMİ İLE İLGİLİ AÇIKLAMA
                                            </div>
                                            <div className="col-auto t-cursorPointer" data-dismiss="modal">
                                                <i
                                                    className="t-icon-cross"
                                                    id="id-modalHeaderIcon"
                                                    style={{ color: "rgb(119, 119, 119)" }}
                                                />
                                            </div>
                                        </div>
                                        {/* Body */}
                                        <div className="row t-modalBodyMailOrder">
                                            <div
                                                className="col-12 "
                                                id="id-modalBody"
                                                style={{ color: "rgb(119, 119, 119)", fontSize: "12pt" }}
                                            >
                                                <strong>
                                                    Kredi kartıyla talimatlar yalnızca “organizasyon ve peşinat ücreti” tutarı toplamı kadar girilebilir.
                                                </strong>
                                                <br />
                                                <strong>
                                                    Girdiğiniz ödeme talimatının gerçekleşebilmesi için;
                                                </strong>
                                                <br />
                                                talimat tarihinde, kaydı girilmiş olan kredi kartında yeterli limit
                                                olması durumunda başarılı gerçekleşecektir.

                                                <br />
                                                Tahsilatın başarılı gerçekleşmesi sonrası taksitlere yansıması 1-2
                                                iş günü sürebilmektedir.
                                            </div>
                                        </div>
                                        {/* footer*/}
                                        <div className="row t-modalFooterMailOrder">
                                            <div
                                                className="col-12"
                                                id="id-modalFooter"
                                                style={{ color: "rgb(102, 102, 102)" }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            );
        }
    }
}

function mapStateToProps(state) {
    return {
        payment: selectPayment(state),
        expenses: selectMemberExpenseByMemberNo(state),
        paymentSumData: selectPaymentSum(state)
    };
}
const mapDispatchToProps = dispatch => ({
    createPaymentOrder: (orderdetail, creditCard) => dispatch(createPaymentPayFor(orderdetail, creditCard)),
    getMemberNumber: () => dispatch(getActiveMemberNumber()),
    getActiveMemberNo: () => dispatch(getActiveMemberNoList()),
    changeCurrentPage: (page) => dispatch(changeCurrentPage(page)),
    getMemberExpense: (memberNo, paymentType) => dispatch(getExpensesByMemberNo(memberNo, paymentType)),
    getPaymentSummary: (memberNo) => dispatch(getPaymentSum(memberNo))
});
export default connect(mapStateToProps, mapDispatchToProps)(CreatePaymentOrderEminPay);